import React, { useEffect, useState } from 'react';
import { F4PasskeyModal } from './F4PasskeyModal';
import { F4FeedbackFormModal } from './F4FeedbackFormModal';

export const GlobalF4Handler: React.FC = () => {
  const [passkeyModalOpen, setPasskeyModalOpen] = useState(false);
  const [feedbackFormOpen, setFeedbackFormOpen] = useState(false);

  useEffect(() => {
    function handleKeyDown(e: KeyboardEvent) {
      if (e.key === 'F4' || e.key === 'F9') {
        // Não interceptar F4/F9 quando estamos no Recorder ou dentro de um iframe (recorder usa iframe)
        if (window.location.pathname.includes('/master/recorder')) return;
        if (window.self !== window.top) return;

        e.preventDefault();
        // Check if Passkey was already granted in this session or local storage
        const passkeyGranted = sessionStorage.getItem('f4_passkey_granted') === 'true' || localStorage.getItem('ac_trello_operator_key') !== null;
        if (passkeyGranted) {
          setFeedbackFormOpen(true);
        } else {
          setPasskeyModalOpen(true);
        }
      }
    }

    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, []);

  return (
    <>
      <F4PasskeyModal
        open={passkeyModalOpen}
        onClose={() => setPasskeyModalOpen(false)}
        onSuccess={() => {
          setPasskeyModalOpen(false);
          setFeedbackFormOpen(true);
        }}
      />

      <F4FeedbackFormModal
        open={feedbackFormOpen}
        onClose={() => setFeedbackFormOpen(false)}
      />
    </>
  );
};
